import { css } from 'styled-components';
import { blue700, smoothInOut, red600 } from '@pleo-io/telescope-tokens';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
/**
 * Applies standard focus styles, that only get rendered in "keyboard mode",
 * i.e. consistent with the new :focus-visible selector
 */


var boxShadow = /*#__PURE__*/css(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    outline: none;\n    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */\n    box-shadow: 0 0 0 2px ", ";\n    transition: ", ";\n    transition-property: box-shadow;\n"])), blue700, smoothInOut);
var boxShadowInvalid = /*#__PURE__*/css(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */\n    box-shadow: 0 0 0 2px ", ";\n"])), red600);
var focusRing = /*#__PURE__*/css(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    [data-js-focus-visible] &:focus {\n        outline: none;\n    }\n\n    [data-js-focus-visible] &[data-focus-visible-added]:focus {\n        outline: none;\n        ", ";\n    }\n\n    [data-js-focus-visible] &[data-focus-visible-added]:focus:invalid {\n        ", ";\n    }\n"])), boxShadow, boxShadowInvalid);
/**
 * Applies focusRing, but is applicable to styles that use
 * hidden elements with styled siblings (like checkboxes or radios)
 */

var focusRingSibling = function focusRingSibling(Element) {
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    [data-js-focus-visible] ", ":focus + & {\n        outline: none;\n    }\n\n    [data-js-focus-visible] ", "[data-focus-visible-added]:focus + & {\n        outline: none;\n        ", ";\n    }\n\n    [data-js-focus-visible] ", "[data-focus-visible-added]:focus:invalid + & {\n        ", ";\n    }\n"])), Element, Element, boxShadow, Element, boxShadowInvalid);
};

export { focusRing, focusRingSibling };